"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Grid = require("../../Layout/Grid");

var _Constant = require("../Constant");

var _VisuallyHidden = _interopRequireDefault(require("../../VisuallyHidden"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  padding: 15px 0px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: inline-flex;\n\n  &:last-of-type {\n    margin-left: 14px;\n  }\n\n  &[data-focus-visible-added]:focus {\n    border-radius: 2px;\n    box-shadow: 0 0 0 4px ", ";\n    /* Visible outline for high contrast mode */\n    outline: 2px solid transparent;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  padding: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var FooterCol = (0, _styledComponents.default)(_Grid.Col)(_templateObject());

var AppStoreLink = _styledComponents.default.a(_templateObject2(), _Constant.Color.FOCUS_B);

var SocialMediaCol = (0, _styledComponents.default)(_Grid.Col)(_templateObject3());

var Footer = function Footer(_ref) {
  var appStoreLinks = _ref.appStoreLinks,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_Grid.Container, null, /*#__PURE__*/_react.default.createElement(_Grid.Row, null, /*#__PURE__*/_react.default.createElement(FooterCol, {
    lg: 8
  }, children), /*#__PURE__*/_react.default.createElement(SocialMediaCol, {
    lg: 4
  }, appStoreLinks.map(function (storeLink) {
    return /*#__PURE__*/_react.default.createElement(AppStoreLink, {
      href: storeLink.url,
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: storeLink.icon,
      alt: storeLink.alt
    }), " ", /*#__PURE__*/_react.default.createElement(_VisuallyHidden.default, null, "Opens in a new tab."));
  }))));
};

Footer.propTypes = {
  /** objects describing app store links */
  appStoreLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    url: _propTypes.default.string,
    icon: _propTypes.default.node,
    alt: _propTypes.default.string
  })),

  /** main footer content */
  children: _propTypes.default.node.isRequired
};
Footer.defaultProps = {
  appStoreLinks: []
};
var _default = Footer;
exports.default = _default;